export default __webpack_public_path__ + "static/media/bscscan.f9d24049.svg";